
export const isInited = (state) => {
  return state.inited
}

export const isOnline = (state) => {
  return state.online
}
